import styled, { css } from 'styled-components';
import { colors, fontSize, fontWeight, media, radius, spacer } from 'settings/style';

export const MembershipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer.lg};
  margin-top: ${spacer.lg};
  width: 100%;
`;

export const MembershipHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer.sm};
`;

export const MembershipTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-family: 'Cormorant Garamond', Georgia, serif;
  color: ${colors.grey900};
  font-weight: 500;
`;

export const MembershipSubtitle = styled.p`
  margin: 0;
  color: ${colors.gray700};
  font-size: ${fontSize.md};
  line-height: 1.5;
`;

export const CurrentPlanBanner = styled.div`
  padding: ${spacer.md} ${spacer.lg};
  border-radius: ${radius.lg};
  background: #f8e39a;
  color: #725200;
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.bold};
`;

export const PlanGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${spacer.md};

  ${media.lg`
    grid-template-columns: 1fr;
  `}
`;

export const PlanCard = styled.button<{ $selected: boolean; $featured?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  padding: ${spacer.lg};
  border-radius: ${radius.lg};
  border: 2px solid #e4e7ec;
  background: ${colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;

  ${({ $featured }) =>
    $featured &&
    css`
      border-color: #1a2744;
    `}

  ${({ $selected }) =>
    $selected &&
    css`
      border-color: #1a2744;
      box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.15);
    `}

  &:hover {
    border-color: #1a2744;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

export const PlanName = styled.h3`
  margin: 0 0 ${spacer.xs};
  font-size: 22px;
  font-family: 'Cormorant Garamond', Georgia, serif;
  color: ${colors.grey900};
`;

export const PlanPrice = styled.div`
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.bold};
  color: #1a2744;
  margin-bottom: ${spacer.sm};
`;

export const PlanDescription = styled.p`
  margin: 0 0 ${spacer.md};
  color: ${colors.gray700};
  font-size: ${fontSize.sm};
  line-height: 1.5;
  flex: 1;
`;

export const PlanFeatureList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const PlanFeatureItem = styled.li`
  font-size: ${fontSize.sm};
  color: ${colors.gray800};
  padding-left: 1.1rem;
  position: relative;

  &::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #1a2744;
    font-weight: ${fontWeight.bold};
  }
`;

export const PlanBadge = styled.span`
  align-self: flex-start;
  margin-bottom: ${spacer.sm};
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #1a2744;
  color: ${colors.white};
  font-size: 0.7rem;
  font-weight: ${fontWeight.bold};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const MembershipActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacer.sm};
  align-items: center;
  padding-top: ${spacer.sm};
`;
